module.exports = __webpack_public_path__ + "static/becoming-coach-b7b48bd928aae0c231d67acd48953d09.png";